import { saveAs } from 'file-saver';
import JSZip from 'jszip';

export function init(app) {
  app.ports.saveRqz.subscribe(async ({ content, name }) => {
    const zip = JSZip();
    zip.file(`${name}.txt`, content);
    const blob = await zip.generateAsync({ type: "blob" });
    saveAs(blob, `${name}.rqz`);
  });

  app.ports.loadRqz.subscribe(async (file) => {
    const zip = JSZip();
    const unzipped = await zip.loadAsync(file);
    unzipped.forEach(async (_, quizFile) => {
      const quiz = await quizFile.async("text");
      app.ports.rqzLoaded.send(quiz.split("\n\n"))
    })
  })
}